import FancyMarket from '../normal/FancyMarket'

/**
 * OddEven market (mname === "oddeven") — reference `.market-6` fancy block.
 */
function OddEven({ onBetLockClick, marketsData = [], exposureData = {}, index }) {
  return (
    <FancyMarket
      marketName="oddeven"
      betLockName="OddEven"
      layout="oddeven"
      index={index ?? 4}
      onBetLockClick={onBetLockClick}
      marketsData={marketsData}
      exposureData={exposureData}
    />
  )
}

export default OddEven
